import React, { useEffect, useContext, useState } from 'react'
import { Col, Row, Card, CardHeader, CardBody, CardTitle } from 'reactstrap'
import ProductContext from 'context/product/productContext'
import ReactTable from 'react-table'
import AuthContext from 'context/auth/authContext'

import {
  getPendingProductComponents,
  pendingColumnHeaders,
  psScrollToTop,
} from './Utilities'
import ProductInfo from './ProductInfo'

const NBSProductsPending = () => {
  const { getInReviewNBSProducts, products, saving, setSaving } = useContext(
    ProductContext
  )
  const { user } = useContext(AuthContext)
  const [isDisabled, setIsDisabled] = useState(false)

  useEffect(() => {
    psScrollToTop()
    console.log('NBSProductsPending: ...loading')
    getInReviewNBSProducts()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (saving) {
      psScrollToTop()
      getInReviewNBSProducts()
      setSaving(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saving])

  useEffect(() => {
    psScrollToTop()
  }, [products])

  // implementation for maximum 1 row expanded at a time
  // const [expanded, setExpanded] = useState({})
  // /* handleRowExpanded ensures a maximum of 1 row expanded at a time */
  // const handleRowExpanded = (newExpanded, index) => {
  //   setExpanded({
  //     [index[0]]: !expanded[index[0]],
  //   })
  // }

  const getProductInfo = product => {
    setIsDisabled(product.fkReviewerOne === user.pkContact)
    product.oldUPC = product.UPC
    const components = getPendingProductComponents(product, isDisabled)
    console.log(components)
    return <ProductInfo {...components} product={product} />
  }

  return (
    <div className="content">
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <CardTitle className="float-left" tag="h4">
                Products Pending - Reviewer 2
              </CardTitle>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={products ?? []}
                filterable
                columns={pendingColumnHeaders}
                defaultPageSize={10}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight primary-pagination"
                SubComponent={({ original }) => getProductInfo(original)}
                // implementation for maximum 1 row expanded at a time
                // expanded={expanded}
                // onExpandedChange={(newExpanded, index) =>
                //   handleRowExpanded(newExpanded, index)
                // }
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default NBSProductsPending
